export default "__VITE_ASSET__ovSEbITc__"